import { Avatar } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { goToBillingPortal, setTrial, getSubscriptionOfUser } from '../../extensions/stripe';
import { PRICE_ID_BASIC, PRICE_ID_GOLD } from '../../utils/constant_data'
import fbConfig from '../../config/fbConfig'
import './AvailablePlans.scss'
import check from '../../assets/comprobar.png'
import { withRouter } from 'react-router';
import { setNullUid } from '../../redux/actions/auth';
import { connect } from 'react-redux';

const AvailablePlans = props => {

    const [subscription, setSubscription] = useState(null)
    useEffect(() => {
        fbConfig.auth().onAuthStateChanged(user => {
            if(!user) {
                props.setNullUid();
                props.history.push('/signin')
            }
        })
        loadSubscription()
    }, [])

    const loadSubscription = async () => {
        const response = await getSubscriptionOfUser();
        if(response && response.role) {
            setSubscription(response.role)
        }
    }

    const goPortal = () => {
        toast.info('Redirigiendo...')
        goToBillingPortal()
    }

    const goTrial = (idPrice) => {
        toast.info('Redirigiendo...');
        setTrial(idPrice)
    }

    return (
        <div className='plans'>
            <div className="plans_content">
                <h2>PLANES DISPOBIBLES</h2>
                <div className='plans_content_full'>
                    <div className='plans_content_full_cards'>
                        
                        <div className='plans_content_full_cards_item'>

                            <div 
                                className='card' 
                                style={{ justifyContent: 'space-between' }}
                                onClick={ subscription ? () => goPortal() : () => goTrial( PRICE_ID_BASIC )} >
                                <div className='card_header'>
                                    <h1>BASIC</h1>
                                </div>
                                <div className='card_content'>
                                    <hr />
                                    <p>Te permite bloquear todos los anuncios de los sitios webs</p>
                                    <hr />
                                </div>
                                <div className='card_price'>
                                    <h1>Gratis</h1>
                                </div>
                            </div>

                            {
                                subscription && subscription === 'basic' ?
                                <div className='activeIcon'>
                                    <Avatar src={check} sx={{ width: 56, height: 56 }} />
                                    <h3>Activa</h3>
                                </div>
                                 : null
                            }
                            
                        </div>
                        
                        <div className='plans_content_full_cards_item'>

                            <div className='card' onClick={ subscription ? () => goPortal() : () => goTrial( PRICE_ID_GOLD )}>
                                <div className='card_header' style={{ background: '#003077' }}>
                                    <h1>GOLD</h1>
                                </div>
                                <div className='card_content' style={{ paddingLeft: '30px', paddingRight: '30px' }}>
                                    <hr />
                                    <p style={{ marginBottom: '0' }}>
                                        Puedes bloquear todo tipo de cookies para evitar que terceros guarden tu información, 
                                        evitar tráfico con tus datos y varias más. Este paquete incluye el <b>bloqueo</b> de:
                                        <br />
                                    </p>
                                    <div style={{ marginTop: '15px' }}>
                                        <b> <img src={require('../../assets/advertisements.png').default} style={{ marginRight: '20px' }} /> Anuncios en sitios webs </b><br />
                                        <b> <img src={require('../../assets/analytics.png').default} style={{ marginRight: '20px' }} /> Cookies analíticas</b><br />
                                        <b> <img src={require('../../assets/security.png').default} style={{ marginRight: '20px' }} /> Cookies de seguridad</b><br />
                                        <b> <img src={require('../../assets/social-media.png').default} style={{ marginRight: '20px' }} /> Cookies de publicidad</b><br />
                                        <b> <img src={require('../../assets/locations.png').default} style={{ marginRight: '20px' }} /> Cookies de seguimiento</b><br />
                                        <b> <img src={require('../../assets/login.png').default} style={{ marginRight: '20px' }} /> Cookies de autenticación</b>
                                    </div>
                                    <hr style={{ marginTop: '25px' }} />
                                </div>
                                <div className='card_price'>
                                    <h1>€4.99 / mes</h1>
                                </div>
                            </div>

                            {
                                subscription && subscription === 'gold' ?
                                <div className='activeIcon'>
                                    <Avatar src={check} sx={{ width: 56, height: 56 }} />
                                    <h3>Activa</h3>
                                </div>
                                 : null
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        setNullUid: () => dispatch(setNullUid())
    }
}

export default connect(null, mapDispatchToProps)(withRouter(AvailablePlans))
